import React, { useState } from 'react';
import WebappAccessMatrix from './WebappAccessMatrix';
import ZonesParking from './ZonesParking';
import './WebappAccess.css';

function WebappAccess({ user, editMode, setHeaderAction }) {
  const [subTab, setSubTab] = useState('acces');

  return (
    <div className="page-container">
      <div className="page-tabs">
        <button
          className={subTab === 'acces' ? 'active' : ''}
          onClick={() => setSubTab('acces')}
        >
          📱 Accès webapp
        </button>
        <button
          className={subTab === 'zones' ? 'active' : ''}
          onClick={() => setSubTab('zones')}
        >
          📍 Zones Parking
        </button>
      </div>

      {subTab === 'acces' && (
        <WebappAccessMatrix user={user} editMode={editMode} setHeaderAction={setHeaderAction} />
      )}
      {subTab === 'zones' && (
        <ZonesParking user={user} editMode={editMode} setHeaderAction={setHeaderAction} />
      )}
    </div>
  );
}

export default WebappAccess;
